import { render, staticRenderFns } from "./FreeHands.vue?vue&type=template&id=c72c4eb4&"
import script from "./FreeHands.vue?vue&type=script&lang=js&"
export * from "./FreeHands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72c4eb4')) {
      api.createRecord('c72c4eb4', component.options)
    } else {
      api.reload('c72c4eb4', component.options)
    }
    module.hot.accept("./FreeHands.vue?vue&type=template&id=c72c4eb4&", function () {
      api.rerender('c72c4eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/FreeHands.vue"
export default component.exports